import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Star, RotateCcw } from "lucide-react";
import { displayUrl } from "./imageUrl";

const POSITIONS = [
  { value: "top", label: "Top" },
  { value: "center", label: "Center" },
  { value: "bottom", label: "Bottom" },
];

export const HeroPicker = ({ hero, onPositionChange, onReset }) => (
  <div className="glass rounded-xl p-6 mb-8" data-testid="hero-picker">
    <div className="flex items-start gap-6 flex-col sm:flex-row">
      <div className="w-full sm:w-56 shrink-0 rounded-lg overflow-hidden bg-sand/30 aspect-[4/3]">
        {hero?.url ? (
          <img data-testid="hero-picker-preview" src={displayUrl(hero.url)} alt={hero.alt || "Home hero"} className="w-full h-full object-cover" style={{ objectPosition: hero.position || "top" }} />
        ) : (
          <div data-testid="hero-picker-empty" className="w-full h-full flex items-center justify-center font-body text-xs text-taupe text-center px-4">Using default hero image</div>
        )}
      </div>
      <div className="flex-1">
        <h3 className="font-heading text-lg text-charcoal flex items-center gap-2"><Star className="w-4 h-4 text-jade-text" /> Home Page Hero</h3>
        <p className="font-body text-sm text-stone-grey mt-1 mb-4">Hover any photo below and open Edit → "Use as Home Hero" to feature it at the top of your home page.</p>
        {hero?.url && (
          <div className="flex flex-wrap items-end gap-3">
            <div>
              <Label className="font-body text-xs text-stone-grey mb-1 block">Focal point</Label>
              <select data-testid="hero-position-select" value={hero.position || "top"} onChange={(e) => onPositionChange(e.target.value)} className="form-input">
                {POSITIONS.map((p) => <option key={p.value} value={p.value}>{p.label}</option>)}
              </select>
            </div>
            <Button type="button" variant="outline" size="sm" onClick={onReset} data-testid="hero-reset-btn">
              <RotateCcw className="w-4 h-4 mr-2" /> Reset to default
            </Button>
          </div>
        )}
      </div>
    </div>
  </div>
);
